export abstract class AXToolbarItem {
  alignment: 'start' | 'end' | 'center' = 'center';
}
